<template>
  <div class="inquiry_index">
    <div class="inquiry_title">
      <el-icon class="el-icon-edit-outline"></el-icon> 询报价
    </div>
    <div class="inquiry_form">
      <div class="inquiry_form_one_title">
        主条款
      </div>
      <div class="inquiry_form_one">
          <el-tag type="primary" class="inquiry_form_one_tag" v-for="mitem in product.main_terms" :key="mitem.id" @click="showDetail('main',mitem.id)">{{mitem.title}}</el-tag>
      </div>
      <div class="inquiry_form_one_title" v-if="product.additional_terms && product.additional_terms.length>0">
        附加额外条款
      </div>
      <div class="inquiry_form_one" v-if="product.additional_terms && product.additional_terms.length>0">
        <el-tag type="primary" class="inquiry_form_one_tag" v-for="aitem in product.additional_terms" :key="aitem.id" @click="showDetail('additional',aitem.id)">{{aitem.title}}</el-tag>
      </div>
      <div class="inquiry_form_one_title" v-if="product.special_terms && product.special_terms.length>0">
        特殊约定
      </div>
      <div class="inquiry_form_one" v-if="product.special_terms && product.special_terms.length>0">
        <el-tag type="warning" class="inquiry_form_one_tag" v-for="sitem in product.special_terms" :key="sitem.id" @click="showDetail('special',sitem.id)">{{sitem.title}}</el-tag>
      </div>
      <div class="inquiry_form_one_title" v-if="product.deductible_terms && product.deductible_terms.length>0">
        免赔责任
      </div>
      <div class="inquiry_form_one" v-if="product.deductible_terms && product.deductible_terms.length>0">
        <el-tag type="danger" class="inquiry_form_one_tag" v-for="ditem in product.deductible_terms" :key="ditem.id" @click="showDetail('deductible',ditem.id)">{{ditem.title}}</el-tag>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>船舶信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船舶查询
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="船名/MMSI/IMO/CN号" v-model="keyword" @input="keywordInput" :readonly="ksearching"></el-input>

          <div class="inquiry_ships_main" v-if="dialogVisible">
            <div class="inquiry_ships_title">
              <span style="width:80%;float:left;font-size:.8rem;color:grey;">船舶搜索结果选择</span>
              <span style="width:20%;float:right;text-align:center;font-size:.8rem;color:#ccc;cursor:default;" @click="closeShips">✖</span>
            </div>
            <div class="inquiry_ships_line" v-if="ships.length===0 && ksearching">
              搜索中...
            </div>
            <div class="inquiry_ships_line" v-if="ships.length===0 && !ksearching">
              未查询到船舶
            </div>
            <div class="inquiry_ships_one" v-for="item in ships" :key="item.mmsi" @click="getShip(item)">
              <div class="inquiry_ships_line">
                {{item.name}} {{item.nameCn ? ' - ' + item.nameCn : ''}}
              </div>
              <div class="inquiry_ships_half_line">
                MMSI:  {{item.mmsi || '-'}}
              </div>
              <div class="inquiry_ships_half_line">
                IMO:  {{item.imo && item.imo > 0 ? item.imo : '-'}}
              </div>
              <div class="inquiry_ships_half_line">
                长/宽:  {{(item.length&&item.length>0?item.length/10:'-')+' / '+(item.width&&item.width>0?item.width/10:'-')}}
              </div>
              <div class="inquiry_ships_half_line">
                类型:  {{item.shipTypeOthers}}
              </div>
              <div class="inquiry_ships_line">
                更新时间:  {{new Date(item.lasttime*1000).toLocaleString()}} <span v-html="checkDate(item.lasttime)"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inquiry_form_one" v-if="form.mmsi">
        <div class="inquiry_form_title">
          船舶MMSI
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="船舶MMSI" v-model="form.mmsi" :readonly="true"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船舶名称 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="船舶名称" v-model="form.ship_name"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船舶类型 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="船舶类型" v-model="form.ship_type"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          总吨
        </div>
        <div class="inquiry_form_input">
          <el-input-number size="small" placeholder="总吨" v-model="form.gross_tonnage"></el-input-number>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          载重 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-input-number size="small" placeholder="载重" v-model="form.dwt"></el-input-number>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船籍港 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="船籍港" v-model="form.home_port"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          航行区域 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-select v-model="form.area" size="small">
            <el-option v-for="(item,index) in area_types" :key="index" :value="index" :label="item">{{item}}</el-option>
          </el-select>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          造船厂 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="船籍港" v-model="form.builder"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          建造年份 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-input-number :min="1900" :max="new Date().getFullYear()" :step="1" :precision="0" :size="4" size="small" placeholder="船籍港" v-model="form.build_year"></el-input-number>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          所有人 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="所有人" v-model="form.ship_owner"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船级社
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="船级社" v-model="form.classification_society"></el-input>
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>保险信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          保险起期 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-date-picker type="date" value-format="timestamp" v-model="form.insurance_begin"></el-date-picker>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          保险止期 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-date-picker type="date" value-format="timestamp" v-model="form.insurance_stop"></el-date-picker>
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>投保人信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          姓名 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="姓名称呼" v-model="form.rfq_name"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          邮箱
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="电子邮箱" v-model="form.rfq_email"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          手机 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="联系手机号" v-model="form.rfq_phone"></el-input>
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>被保人信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          姓名 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="姓名称呼" v-model="form.insured_name"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          邮箱
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="电子邮箱" v-model="form.insured_email"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          手机 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="联系手机号" v-model="form.insured_phone"></el-input>
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>其他信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船舶证书
        </div>
        <div class="inquiry_form_input">
          <el-upload
            name="files"
            :action="domain+`/file/upload`"
            :multiple="true"
            :before-upload="beforeUploadImg"
            :on-error="errorUpload"
            :on-success="successUploadImg"
            :with-credentials="true"
            :file-list="imgList">
            <el-button size="small" style="width:100%;">上传证书<el-icon class="el-icon-upload2"></el-icon></el-button>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="inquiry_bottom">
      <el-button type="primary" style="width:90%;margin:0 5%;" @click="submit">提交询报价</el-button>
    </div>
    <el-dialog
      :title="dtypes[dtype]"
      :visible.sync="detailDialogVisible" fullscreen>
      <h3>《{{ detail.title }}》</h3>
      <div v-html="detail.content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getDomain,searchShipsParams,getShipModeltype,getShipRiskRoute,getInsuranceProductsById,addInsuranceOrder,insuranceMainTermsById,insuranceAdditionalTermsById,insuranceSpecialTermsById,insuranceDeductibleTermsById } from '../../api/api'
  import { getJsonStorage } from "../../util/storage";

  export default {
    name: "InquiryAdd",
    data() {
      return {
        id:this.$route.query.id,
        domain:getDomain(),
        product:{},
        mid:[],
        aid:[],
        sid:[],
        did:[],
        keyword:'',
        ktimeout:null,
        ksearching:false,
        ships:[],
        dialogVisible:false,
        area_types:['内河','远洋','沿海'],
        imgList:[],
        form:{
          ship_name:null,
          mmsi:null,
          dwt:null,
          gross_tonnage:null,
          area:null,
          ship_owner:null,
          ship_type:null,
          home_port:null,
          build_year:new Date().getFullYear()-5,
          valuation:null,
          classification_society:null,
          insurance_begin:new Date().valueOf(),
          insurance_stop: new Date().valueOf()+86400000*365,
          shipcerts:[],
          rfq_name:null,
          rfq_email:null,
          rfq_phone:null,
          insured_name:null,
          insured_email:null,
          insured_phone:null,
          insurance_name:null,
          insurance_email:null,
          insurance_phone:null,
          modeltype:null
        },
        maxsize:1024*1024*10,
        dtype:'',
        detail:{},
        detailDialogVisible:false,
        dtypes:{'main':'主险','additional':'附加险','special':'特别约定','deductible':'免赔条款'},
        user: getJsonStorage('rfq_user') || {}
      }
    },
    mounted() {
      getInsuranceProductsById(this.id).then(res => {
        if(res && res.status === 0 && res.data){
          this.product = res.data;
          this.mid = [];
          this.product.main_terms.forEach((mitem) => {
            if(mitem.isbind) this.mid.push(mitem.id);
          });
          this.aid = [];
          this.product.additional_terms.forEach((aitem) => {
            if(aitem.isbind) this.aid.push(aitem.id);
          });
          this.sid = [];
          this.product.special_terms.forEach((sitem) => {
            if(sitem.isbind) this.sid.push(sitem.id);
          });
          this.did = [];
          this.product.deductible_terms.forEach((ditem) => {
            if(ditem.isbind) this.did.push(ditem.id);
          });
        }
      });
      if(this.user){
        this.form.rfq_name = this.user.user_realname || this.user.nickname || this.user.username;
        this.form.rfq_email = this.user.email;
        this.form.rfq_phone = this.user.phone;
        this.form.insured_name = this.user.user_realname || this.user.nickname || this.user.username;
        this.form.insured_email = this.user.email;
        this.form.insured_phone = this.user.phone;
      }
    },
    methods: {
      submit(){
        let data = JSON.parse(JSON.stringify(this.form));
        if(!data['ship_name']){
          this.$message.error("请填写船名");
          return;
        }
        if(!data['ship_type']){
          this.$message.error("请填写船舶类型");
          return;
        }
        if(!data['dwt']){
          this.$message.error("请填写载重");
          return;
        }
        if(!data['gross_tonnage']){
          this.$message.error("请填写总吨");
          return;
        }
        if(!data['insurance_begin']){
          this.$message.error("请填写保险起期");
          return;
        }
        if(!data['insurance_stop']){
          this.$message.error("请填写保险止期");
          return;
        }
        if(!data['rfq_name'] || !data['rfq_phone']){
          this.$message.error("请填写询价人信息");
          return;
        }
        if(data['rfq_phone'].length<8 || !(/[\d\+\-]{8,15}/ig.test(data['rfq_phone']))){
          this.$message.error("询价人电话号码格式不正确");
          return;
        }
        data['insurance_begin'] = parseInt(data['insurance_begin']/1000);
        data['insurance_stop'] = parseInt(data['insurance_stop']/1000);
        let shipcerts = [];
        if(this.imgList && this.imgList.length > 0){
          for(let m in this.imgList){
            shipcerts.push(this.imgList[m]['url']);
          }
        }
        data['shipcerts'] = JSON.stringify(shipcerts);
        data['insurance_products'] = this.id;
        data['insurance_main_terms'] = JSON.stringify(this.mid);
        data['insurance_additional_terms'] = JSON.stringify(this.aid);
        data['insurance_specials'] = JSON.stringify(this.sid);
        data['insurance_deductible'] = JSON.stringify(this.did);
        addInsuranceOrder(data).then(res => {
          if(res && res.status === 0){
            this.$message.success("提交成功");
            this.$router.push('/inquiry/index')
          }
        });
      },
      beforeUploadImg(e){
        if(e.type.indexOf('image')===-1 && e.type.indexOf('pdf')===-1){
          this.$message.warning('文件格式错误:'+e.name);
          return false;
        }
        if(e.size > this.maxsize){
          this.$message.warning('文件超过:10MB');
          return false;
        }
        return true;
      },
      errorUpload(e){
        this.$message.success('上传失败:'+e);
      },
      successUploadImg(e){
        if(e.status === 403){
          if(getBrowserType()===1){
            this.$wx.miniProgram.redirectTo({url: '/pages/login/login'})
          }else{
            this.$router.push('/index/login');
          }
        }else if(e.status === 0){
          this.imgList.push({name:e.data[0]['filename'],url:e.data[0]['path']});
          this.$message.success('上传成功');
        }else{
          this.$message.error(e.message);
        }
      },
      keywordInput(e){
        let that = this;
        if(this.ktimeout != null){
          clearTimeout(this.ktimeout);
          this.ktimeout = null;
        }
        if(!this.ksearching){
          that.ships = [];
          this.ktimeout = setTimeout(()=>{
            if(this.keyword!=null && this.keyword.length>0){
              that.ksearching = true;
              that.keyword = that.keyword.toUpperCase();
              searchShipsParams({keyword:that.keyword,merge:1}).then(res => {
                if(res != null && res.status === 0 && res.data){
                  that.ships = res.data;
                  that.dialogVisible = true;
                }
              }).finally(res => {
                that.ksearching = false;
                clearTimeout(that.ktimeout);
                that.ktimeout = null;
              })
            }else{
              that.ksearching = false;
              if(that.ktimeout != null){
                clearTimeout(that.ktimeout);
                that.ktimeout = null;
              }
            }
          },600);
        }
      },
      closeShips(){
        this.dialogVisible = false;
        this.keyword = null;
        this.ksearching = false;
        if(this.ktimeout != null){
          clearTimeout(this.ktimeout);
          this.ktimeout = null;
        }
        this.ships = [];
      },
      checkDate(timestamp){
        let now = parseInt(new Date().valueOf()/1000);
        if(now - timestamp <= 3600){
          return '<span style="color:green;">【一小时内】</span>'
        }else if(now - timestamp <= 86400){
          return '<span style="color:#03a7d5;">【一天内】</span>'
        }else if(now - timestamp <= 86400 * 7){
          return '<span style="color:blue;">【'+Math.ceil((now - timestamp)/86400)+'天内】</span>'
        }else if(now - timestamp <= 86400 * 30){
          return '<span style="color:orange;">【'+parseInt((now - timestamp)/86400)+'天前】</span>'
        }else{
          return '<span style="color:red;">【一个月前】</span>'
        }
      },
      getShip(ship){
        let mmsi = JSON.parse(JSON.stringify(ship))['mmsi'];
        this.closeShips();
        let form = this.form;
        getShipModeltype(mmsi).then(res => {
          if(res && res.status === 0){
            form = {...form,...
              {
                ship_name:res.data.name_cn || res.data.name_en,
                mmsi:res.data.mmsi,
                imo:res.data.imo || null,
                dwt:res.data.dwt || 0,
                gross_tonnage:res.data.gt_final || res.data.gt || 0,
                ship_type:res.data.ship_type_others,
                modeltype:res.data.modeltype,
                classification_society:res.data.classification_society,
                ship_owner:res.data.shipowner_ch || res.data.shipowner_en,
                builder:res.data.builder_show_name || null,
                build_year:res.data.date_build!=null && res.data.date_build>0 ? new Date(res.data.date_build*1000).getFullYear() : null,
                build_date:res.data.date_build,
                home_port:res.data.home_port
              }
            };
            getShipRiskRoute(mmsi).then(res2 => {
              if(res2 && res2.status === 0){
                form.area = res2.data.area_type;
              }
            }).finally(f => {
              this.form = form;
            })
          }
        }).finally(f => {
          this.form = form;
        });
      },
      showDetail(dtype,id){
        this.dtype = dtype;
        switch(dtype){
          case 'main':
            insuranceMainTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'additional':
            insuranceAdditionalTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'special':
            insuranceSpecialTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'deductible':
            insuranceDeductibleTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          default:
            break;
        }
      }
    }
  }
</script>

<style scoped>
  .inquiry_index {
    top: 6vh;
    left: 0;
    position: absolute;
    height: 94vh;
    width: 100%;
    margin: 0;
    background-color: #fefefe;
    overflow-y: scroll;
  }
  .inquiry_title {
    height:2rem;
    line-height:2rem;
    text-indent: .5rem;
    font-size:.95rem;
    color:#03a7d5;
  }
  .inquiry_bottom {
    width:100%;
    position:absolute;
    bottom:0;
    height:4.2rem;
    line-height:3rem;
    border-top:1px #ddd dashed;
  }
  .inquiry_form {
    height:79vh;
    overflow-y: scroll;
  }
  .inquiry_form_one {
    float:left;
    min-height:2.7rem;
    line-height:2.7rem;
    width:90%;
    margin:.5rem 5%;
  }
  .inquiry_form_title {
    width:20%;
    float:left;
    font-size:.8rem;
    color:#666;
    height:2.7rem;
    line-height:3rem;
  }
  .inquiry_form_input {
    margin-left:3%;
    width:75%;
    float:left;
    height:2.7rem;
    line-height:2.7rem;
  }
  .inquiry_media_box {
    width:100%;
    height:5rem;
    overflow:hidden;
  }
  .inquiry_media_one {
    height:5rem;
    width:20%;
    margin:.5rem 5%;
  }
  .inquiry_form_one_title {
    float:left;
    font-size:.8rem;
    color:#03a7d5;
    height:1.2rem;
    line-height:1.2rem;
    text-indent: 1rem;
  }
  .inquiry_ships_main {
    position:relative;
    margin-left:-32%;
    width:132%;
    height:38vh;
    background:rgb(255,255,255);
    z-index:9999;
    overflow-y: scroll;
    border:1px solid #eee;
    border-radius:.5rem;
  }
  .inquiry_ships_title {
    height:2rem;
    line-height:2rem;
    font-size:1rem;
    text-indent: .5rem;
  }
  .inquiry_ships_one {
    height:6rem;
    width:96%;
    margin-left:2%;
    border-top:1px dashed #ccc;
  }
  .inquiry_ships_line {
    width:100%;
    float:left;
    height:1.5rem;
    line-height:1.5rem;
    font-size:.75rem;
    color:grey;
    overflow-x:hidden;
  }
  .inquiry_ships_half_line {
    width:49%;
    float:left;
    height:1.5rem;
    line-height:1.5rem;
    font-size:.75rem;
    color:grey;
    overflow-x:hidden;
  }
  .inquiry_red_star {
    color:red;
  }
  .inquiry_form_one_tag {
    max-width:100%;
    overflow-x: scroll;
    margin-right:.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/inquiry/add.vue